import { render, staticRenderFns } from "./Marca.vue?vue&type=template&id=2640909a&"
import script from "./Marca.vue?vue&type=script&lang=js&"
export * from "./Marca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports